import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    // <React.StrictMode>
        <App />
    // </React.StrictMode>
);

// Add Rewardful scripts
(function(w: any, r: any) {
    w._rwq = r;
    w[r] = w[r] || function() {
        (w[r].q = w[r].q || []).push(arguments);
    };
})(window, 'rewardful');

// Create and append the async script tag
const rewardfulScript = document.createElement('script');
rewardfulScript.src = 'https://r.wdfl.co/rw.js';
rewardfulScript.async = true;
rewardfulScript.setAttribute('data-rewardful', '6e1ec2');
document.body.appendChild(rewardfulScript);

// Add Doable script
// const doableScript = document.createElement('script');
// doableScript.src = 'https://doable.sh/api/widget/e1bbfb9f-db89-422f-ad7d-09669e172959';
// doableScript.async = true;
// document.body.appendChild(doableScript);
